module.exports = __webpack_public_path__ + "ir.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ir.svg
// module id = 617
// module chunks = 0